module.exports = __webpack_public_path__ + "img/xn.de9755e7.png";